// home file for utils exporting all necessary modules

import ToastNotification from './toasts';
import {
  launchCustomNotification,
  launchSuccessNotification,
  launchErrorNotification,
} from './toasts';
import { getHighestEventClass } from './getHighestEventClass';
import { LocalStorageHandler } from './localStorageHandler';

const launchToast = {
  custom: launchCustomNotification,
  success: launchSuccessNotification,
  error: launchErrorNotification,
};

export {
  ToastNotification,
  launchToast,
  getHighestEventClass,
  LocalStorageHandler,
};
